import { fetchWrapper } from "./index.js";

const getApiUrl = () => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  // console.log('API Base Url', baseUrl);
  if (!baseUrl) {
    console.error('VITE_API_BASE_URL is not defined in environment variables');
    //return 'https://api.investormatch.ai/v1'; // Fallback to production URL
  }
  return `${baseUrl}/v1`;
};

const getAdminApiUrl = () => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  if (!baseUrl) {
    console.error('VITE_API_BASE_URL is not defined in environment variables');
    //return 'https://api.investormatch.ai/admin/v1'; // Fallback to production URL
  }
  return `${baseUrl}/admin/v1`;
};

const getTenantAdminApiUrl = () => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  if (!baseUrl) {
    console.error('VITE_API_BASE_URL is not defined in environment variables');
    //return 'https://api.investormatch.ai/tenant_admin/v1'; // Fallback to production URL
  }
  return `${baseUrl}/tenant_admin/v1`;
};

const _fetchV1 = fetchWrapper(getApiUrl(), {});

export const fetchV1 = _fetchV1;

const _fetchAdminV1 = fetchWrapper(getAdminApiUrl(), {});

export const fetchAdminV1 = _fetchAdminV1;

const _fetchTenantAdminV1 = fetchWrapper(getTenantAdminApiUrl(), {});

export const fetchTenantAdminV1 = _fetchTenantAdminV1;
